export const getReportId = "/DynamicReport/GetReportId";
export const getInterfaceId = "/DynamicForm/GetInterfaceId";
export const GenerateDynamicForm = "api/DynamicForm/GenerateForm";
export const ValidateDynamicFormFields = "/DynamicForm/ValidateFormFieldsAsync";

export const getFormConfigDetails = "/DynamicForm/GenerateForm";
export const executeAction = "/DynamicForm/ExecuteAction";
export const getFormValues = "/DynamicForm/GetFormValues";
export const getDynamicFormTabs = "/DynamicForm/GetDynamicFormTabs";
export const getCascadeFieldOptions = "/DynamicForm/GetCascadeFieldOptions";
export const UploadFile = "/DynamicForm/UploadFile";

// Dynamic Report Api

export const generateReport = "/DynamicReport/GenerateReport";
export const fetchReportData = "/DynamicReport/FetchReportData";
export const fetchReportExcelData = "/DynamicReport/FetchReportExcelData";
export const FetchReportPdfData = "/DynamicReport/FetchReportPdfData";
export const executeReportAction = "/DynamicReport/ExecuteAction";
export const fetchStaticTableData = "/DynamicReport/FetchStaticTableData";

// Login Api
export const getAuthenticationConfig = "/Login/GetAuthenticationConfig";
export const userLogin = "/Login/UserLogin";
export const SetRole = "/Login/SetRole";
export const getValidationMessages = "/Login/GetValidationMessages";
export const getForgotPassword = "/Login/ForgotPassword"; // NOSONAR: Component import
export const getResetPassword = "/Login/ResetPassword"; // NOSONAR: Component import
export const getPasswordExists = "/Login/GetPasswordExists"; // NOSONAR: Component import
export const generateTokenForAuthentication =
  "/Login/GenerateTokenForAuthentication";
export const azuregenerateTokenForAuthentication =
  "/Login/AzureGenerateTokenForAuthentication";
export const getvalidateOtp = "/Login/ValidateOTP";
export const getRefreshtoken = "/Auth/Refresh";
export const getAuthenticationType = "/Login/GetAuthenticationType";
export const userLogout = "/Login/LogoutUser";
export const getUserAccess = "/Login/GetUserAccess";

// Added a common method for the getting the authconfig data.
export const getConfigData = "/Auth/GetConfigData";
export const getPasswordEncryptionConfigData =
  "/Auth/GetPasswordEncryptionConfigData"; // NOSONAR: Component import

export const deleteRecordById = "/DynamicForm/DeleteRecordById";
export const getPermissions = "/Login/GetPermissions";

// Role Management
export const getUserRoles = "/Roles/GetUserRoles";
export const getDynamicMenu = "/DynamicForm/GetDynamicMenu";

//Schedule Master
export const testScheduler = "/DynamicForm/TestScheduler";
export const InsertUpdateSchedule = "/Scheduler/InsertUpdateSchedule";
export const GetMessageTemplate = "/Scheduler/GetMessageTemplate";
export const GetScheduleById = "/Scheduler/GetScheduleById";
export const StartPauseScheduleById = "/Scheduler/StartPauseScheduleById";

export const DeleteTestSHMasterById = "/DynamicForm/DeleteTestSHMasterById";

export const GetRolesSystemName = "/Master/GetRolesSystemName";

export const CustomFunction = "/DynamicForm/CustomFunction";
export const InsertUpdateUserMaster =
  "/UserAccessMaster/InsertUpdateUserMaster";

export const getUserDeptAndUnit = "/UserDetail/GetUserDeptAndUnitData";
//Task Detail Tab
export const getAssignedTo = "/TaskDetail/GetAssignedToOptions";
export const getTaskOwnerStatus = "/TaskDetail/GetTaskOwnerStatusOptions";
export const getTaskRDManagerStatus =
  "/TaskDetail/GetTaskRDManagerStatusOptions";
export const getTaskSummaryDetails = "/TaskDetail/GetTaskSummaryDetails";
export const insertUpdateTaskDetails = "/TaskDetail/InsertTasksAsync";
export const updateTaskDetailByTaskOwner = "/TaskDetail/UpdateTaskAsync";
export const getRequestDetailsById = "/TaskDetail/FetchRequestDetailsData";
export const getTaskHistory = "/TaskDetail/GetTaskHistoryDetails";

export const AcknowledgeRequest = "/Custom/AcknowledgeRequest";
export const InitiateRequestWorkflow = "/Custom/InitiateRequestWorkflow";
export const getTargetClosureDateByPriority = "/Custom/GetTargetClosureDate";
export const RequestClosure = "/Custom/RequestClosureAsync";
export const getProductCodeByProduct = "/Custom/GetProductCode";
export const getRequestHistory = "/Custom/GetRequestHistoryDetails";
export const getPowerBiReportId = "/api/PowerBI/GetReportId";
export const GetUserDeptAndUnitDataForReport =
  "/api/PowerBI/GetUserDeptAndUnitDataForReport";
